export default "__VITE_ASSET__DRXHExxq__"